<template>
  <div>
    <h3 class="text-gray-700 text-3xl font-medium">Mailings</h3>
  </div>
</template>

<script>


export default {
  name: "Mailings",
  data(){
    return {

    }
  }
}
</script>

<style scoped>

</style>
